<template>
    <div class="bjex-main" v-loading="loading">
        <div class="school-line"></div>
        <el-form label-width="80px">
            <el-form-item label="资源类型:">
                <el-button type="text" @click="(curPage = 1), (resTypeId = ''), resourcequeryList()"
                    :class="resTypeId === '' ? '' : 'yanse'">全部</el-button>
                <el-button type="text" @click="(curPage = 1), (resTypeId = item.id), resourcequeryList()"
                    :class="resTypeId === item.id ? '' : 'yanse'" v-for="item in resource_typelist" :key="item.id">{{
                        item.name }}</el-button>
            </el-form-item>
            <el-form-item label="资源来源:">
                <el-button type="text" @click="; (curPage = 1), (resSourceId = ''), resourcequeryList()"
                    :class="resSourceId == '' ? '' : 'yanse'">全部</el-button>
                <el-button type="text" @click="(curPage = 1), (resSourceId = item.id), resourcequeryList()"
                    :class="item.id == resSourceId ? '' : 'yanse'" v-for="item in resource_originlist" :key="item.id">{{
                        item.name
                    }}</el-button>
            </el-form-item>
            <el-form-item label="资源阶段:">
                <el-button type="text" @click="(curPage = 1), (resStep = ''), resourcequeryList()"
                    :class="resStep == '' ? '' : 'yanse'">全部</el-button>
                <el-button type="text" @click="; (curPage = 1), (resStep = item.id), resourcequeryList()"
                    :class="item.id == resStep ? '' : 'yanse'" v-for="item in resource_steplist" :key="item.id">{{
                        item.name
                    }}</el-button>
            </el-form-item>
            <el-form-item label="使用对象:">
                <el-button type="text" @click="(curPage = 1), (userType = -1), resourcequeryList()"
                    :class="userType == -1 ? '' : 'yanse'">全部</el-button>
                <el-button type="text" @click="(curPage = 1), (userType = 0), resourcequeryList()"
                    :class="userType == 0 ? '' : 'yanse'">老师使用</el-button>
                <el-button type="text" @click="(curPage = 1), (userType = 1), resourcequeryList()"
                    :class="userType == 1 ? '' : 'yanse'">学生使用</el-button>
            </el-form-item>
        </el-form>
        <div style="display: flex; justify-content: space-between; align-items: center">
            <div>
                <el-input v-model="resTitle" clearable placeholder="请输入搜索关键词" size="small"
                    style="width: 200px"></el-input>
                    <el-button type="primary" size="small" @click="(curPage = 1), resourcequeryList()">搜索</el-button>
            </div>
        </div>
        <el-table :row-style="{ height: '48px' }" :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
            style="width: 100%;margin-top: 20px;" border stripe ref="studentTable" :data="TableList"
            @selection-change="handleSelectionChange">
            <el-table-column type="index" align="center" />
            <el-table-column label="资源名称" prop="resTitle" align="center" width="320"></el-table-column>
            <el-table-column label="资源类型" prop="resTypeTitle" align="center">
            </el-table-column>
            <el-table-column align="center" label="使用对象">
                <template slot-scope="scope">
                    {{ scope.row.userType == 0 ? '教师使用' : '学生使用' }}
                </template>
            </el-table-column>
            <el-table-column label="关联书籍" align="center">
                <template slot-scope="scope">
                    <span v-for="item in scope.row.bookList" :key="item">{{ item }}，</span>
                </template>
            </el-table-column>
            <el-table-column label="添加时间" align="center">
                <template slot-scope="scope">
                    {{ scope.row.createTime }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="210" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="bian(scope.row)">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页区域 -->
        <el-pagination style="text-align: right; padding: 10px" @prev-click="change" @next-click="change"
            :page-size="10" @current-change="change" background layout="total,prev, pager, next"
            :hide-on-single-page="true" :total="totalCount"></el-pagination>
        <el-dialog title="关联书籍" :visible.sync="Dialog" width="1200px">
            <el-form label-width="80px">
                <el-form-item label="图书状态:">
                    <el-button type="text" @click="; (publishStatus = ''), queryBookList()"
                        :class="publishStatus === '' ? '' : 'yanse'">全部</el-button>
                    <el-button type="text" @click="; (publishStatus = 0), queryBookList()"
                        :class="publishStatus === 0 ? '' : 'yanse'">未发布</el-button>
                    <el-button type="text" @click="; (publishStatus = 1), queryBookList()"
                        :class="publishStatus === 1 ? '' : 'yanse'">已发布</el-button>
                </el-form-item>
                <el-form-item label="适合年级:">
                    <el-button type="text" @click="; (gradeId = ''), queryBookList()"
                        :class="gradeId == '' ? '' : 'yanse'">全部</el-button>
                    <el-button type="text" @click="; (gradeId = item.id), queryBookList()"
                        :class="item.id == gradeId ? '' : 'yanse'" v-for="item in gradelist" :key="item.id">{{ item.name
                        }}</el-button>
                </el-form-item>
                <el-form-item label="所属专栏:">
                    <el-button type="text" @click="; (specialId = ''), queryBookList()"
                        :class="specialId == '' ? '' : 'yanse'">全部</el-button>
                    <el-button type="text" @click="; (specialId = item.code), queryBookList()"
                        :class="item.code == specialId ? '' : 'yanse'" v-for="item in specialColumn" :key="item.code">{{
                            item.name
                        }}</el-button>
                </el-form-item>
            </el-form>
            <div>
                <el-cascader clearable v-model="classifyId" @change="queryBookList" placeholder="请选择图书所属分类"
                    :options="options" :show-all-levels="false" size="small"></el-cascader>
                <el-select v-model="bookLevel" placeholder="请选择图书等级" clearable size="small">
                    <el-option v-for="item in bookLevelLists" :key="item.id" :label="item.name" :value="item.code">
                    </el-option>
                </el-select>
                <el-input v-model="bookName" clearable placeholder="请输入图书名称关键词" size="small"
                    style="width: 200px"></el-input>
                <el-button type="primary" size="small" @click=" (curPage1 = 1), queryBookList()">搜索</el-button>
            </div>
            <el-table :data="tableData" border stripe style="width: 100%;margin-top: 20px;" highlight-current-row
                ref="multipleTable" @selection-change="handleSelectionChanges">
                <el-table-column type="selection" align="center" />
                <el-table-column label="封面" align="center" width="130">
                    <template slot-scope="scope">
                        <el-image style="width: 100px; height: 120px"
                            :src="scope.row.bookImgUrl ? scope.row.serverHttp + scope.row.bookImgUrl : ''" fit="cover">
                            <div slot="error" class="image-err">暂无封面</div>
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="bookName" label="名称" align="center"></el-table-column>
                <el-table-column prop="bookGradesName" label="适合年级" align="center"></el-table-column>
                <el-table-column prop="bookStarNumber" label="阅读分级（星星值）" align="center"></el-table-column>
                <el-table-column prop="bookAuthor" label="作者" align="center"> </el-table-column>
                <el-table-column prop="publishingName" label="出版社" align="center"></el-table-column>
                <el-table-column prop="bookCode" label="编号" align="center"></el-table-column>
                <el-table-column label="状态" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.publishStatus == 1 ? (scope.row.delistStatus == 1 ? '已上架' : '未上架') : '未发布' }}
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="text-align: right; padding: 10px" @prev-click="change1" @next-click="change1"
                :page-size="10" @current-change="change1" background layout="total,prev, pager, next"
                :hide-on-single-page="true" :total="totalCount1"></el-pagination>
            <div style="text-align: right;margin: 20px 0;">
                <el-button @click="Dialog = false">取消</el-button>
                <el-button type="primary" @click="ques">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import * as homeApi from '@/api/home'
import { ERR_OK, BASE_URL } from '@/api/index'
export default {
    data() {
        return {
            loading: false,
            bookLevelList: [],
            bookRelation: '',
            resTitle: '',
            resLimit: '',
            resource_typelist: [],
            resource_originlist: [],
            resTypeId: '',
            resSourceId: '',
            resource_steplist: [],
            resStep: '',
            curPage: 1,
            pageSize: 10,
            userType: -1,
            totalCount: 0,
            TableList: [],
            multipleSelection: [],
            Dialog: false,
            tableData: [],
            totalCount1: 0,
            gradelist: [],
            gradeId: '',
            specialId: '',
            specialColumn: [],
            curPage1: 1,
            bookCode: '',
            bookName: '',
            bookLevel: '',
            bookLevelLists: [],
            options: [],
            publishStatus: '',
            classifyId: [],
            multipleSelections: []
        }
    },
    created() {
        this.dictcode()
        this.dictcode1()
        this.dictcode2()
        this.dictcode3()
        this.resourcequeryList()
        this.getGradeStage()
        this.dictcode5()
        this.dictcode4()
        this.getTreeReadClassify()
    },
    watch: {

    },
    methods: {
        sahnchus(s){
            let that = this;
            let params = {
                // id: s.id,
                resId:s.resId
            };
            this.$confirm("删除后无法恢复，确定删除？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    homeApi
                        .resourcedel(params)
                        .then(res => {
                            if (res.data.code == "0") {
                                that.$message({
                                    message: "删除成功",
                                    type: "success"
                                });
                                this.resourcequeryList()
                            }
                        })
                        .catch(() => { });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },
        exportFun() {
            let params = {
                curPage: this.curPage,
                    pageSize: 10,
                    resTypeId: this.resTypeId,
                    resSourceId: this.resSourceId,
                    resStep: this.resStep,
                    userType: this.userType == -1 ? '' : this.userType,
                    resLimit: this.resLimit,
                    bookRelation: this.bookRelation,
                    resTitle: this.resTitle
            }
            var url = BASE_URL + '/read/read-resource/export'
            var xhr = new XMLHttpRequest()
            let userType=this.userType == -1 ? '' : this.userType
            xhr.open('GET', url + '?resTypeId='+this.resTypeId + '&pageNum=' + this.curPage + '&resSourceId=' + this.resSourceId + '&resSourceId=' + this.resSourceId + '&resStep=' + this.resStep + '&userType=' + userType+ '&resLimit=' + this.resLimit+ '&bookRelation=' + this.bookRelation+ '&resTitle=' + this.resTitle, true)
            xhr.setRequestHeader('token', localStorage.getItem('token'))
            xhr.responseType = 'blob' // 设置返回类型blob
            // 定义请求完成的处理函数，请求前也可以增加 加载框/禁用下载按钮的相关逻辑
            xhr.onload = function () {
                if (this.status === 200) {
                    var blob = this.response
                    var reader = new FileReader()
                    reader.readAsDataURL(blob) // 转换为base64，可以直接放入a标签href
                    reader.onload = function (e) {
                        // 转换完成后创建a标签下载
                        var a = document.createElement('a')
                        a.download = '资源清单.xlsx'
                        a.href = e.target.result
                        a.click()
                    }
                }
            }
            xhr.send()
        },
        removeDuplicates(array) {
            return [...new Set(array)];
        },
        ques() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    type: 'info',
                    message: '请选择关联书籍!'
                })
            } else {
                let that = this
                let bookIds = []
                let resIds = []
                for (var i = 0; i < this.multipleSelection.length; i++) {
                    resIds.push(this.multipleSelection[i].resId)
                    console.log(resIds)
                }
                for (var i = 0; i < this.multipleSelections.length; i++) {
                    bookIds.push(this.multipleSelections[i].id)
                    console.log(bookIds)
                }
                // return false
                let params = {
                    bookIds: bookIds.toString(),
                    resIds: resIds.toString(),
                }
                homeApi
                    .resourcelinkBook(params)
                    .then((res) => {
                        this.Dialog = false
                        this.queryBookList()
                    })
                    .catch(() => { })

            }
        },
        multipl() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    type: 'info',
                    message: '请选择资源!'
                })
            } else {
                this.queryBookList()
            }
        },
        change1(s) {
            this.curPage1 = s
            this.queryBookList()
        },
        xunahj(s) {
            s.forEach((item) => {
                item.value = item.id
                item.label = item.classifyName
                if (item.chilrenList && item.chilrenList.length > 0) {
                    item.children = item.chilrenList
                    this.xunahj(item.children)
                }
            })
            return s
        },
        getTreeReadClassify() {
            let that = this
            let params = {
                schoolId: -1
            }
            homeApi
                .getTreeReadClassify(params)
                .then((res) => {
                    res.data.data = that.xunahj(res.data.data)
                    that.options = res.data.data
                })
                .catch(() => { })
        },
        dictcode3() {
            let that = this
            homeApi
                .dictcode({
                    code: 'special_column'
                })
                .then((res) => {
                    that.specialColumn = res.data.data
                })
        },
        //年级列表
        getGradeStage() {
            let that = this
            homeApi
                .getGradeStage({
                    stage: 5
                })
                .then((res) => {
                    that.gradelist = res.data.data
                })
        },
        queryBookList() {
            let that = this
            this.loading = true
            // console.log(this.leafClassifyId)
            let params = {
                schoolId: -1,
                pageNum: this.curPage1,
                pageSize: 10,
                bookCode: this.bookCode,
                bookName: this.bookName,
                bookLevel: this.bookLevel,
                publishStatus: this.publishStatus.toString(),
                classifyId: this.classifyId.length > 0 ? this.classifyId[this.classifyId.length - 1].toString() : '',
                bookGrades: this.gradeId.toString(),
                specialColumn: this.specialId.toString()
            }
            homeApi
                .queryBookList(params)
                .then((res) => {
                    that.tableData = res.data.data.dataList
                    that.totalCount1 = res.data.data.totalCount
                    that.loading = false
                    this.Dialog = true
                })
                .catch(() => {
                    that.loading = false
                })
        },
        change(s) {
            this.curPage = s
            this.resourcequeryList()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
            console.log(val)
        },
        handleSelectionChanges(val) {
            this.multipleSelections = val
            console.log(this.multipleSelections)
        },
        resourcequeryList() {
            let that = this
            homeApi
                .resourcequeryList({
                    curPage: this.curPage,
                    pageSize: 10,
                    resTypeId: this.resTypeId,
                    resSourceId: this.resSourceId,
                    resStep: this.resStep,
                    userType: this.userType == -1 ? '' : this.userType,
                    resLimit: this.resLimit,
                    bookRelation: this.bookRelation,
                    resTitle: this.resTitle
                })
                .then((res) => {
                    this.TableList = res.data.data.dataList
                    this.totalCount = res.data.data.totalCount
                })
        },
        bian(s) {
            localStorage.setItem('bookId', '')
            localStorage.setItem('resId', s.resId)
            this.$emit('navlink', 'read_add')
        },
        read_add() {
            localStorage.setItem('bookId', '')
            localStorage.setItem('resId', '')
            this.$emit('navlink', 'read_add')
        },
        read_settings() {
            this.$emit('navlink', 'read_settings')
        },
        dictcode() {
            let that = this
            homeApi
                .dictcode({
                    code: 'resource_type'
                })
                .then((res) => {
                    that.resource_typelist = res.data.data
                })
        },
        dictcode1() {
            let that = this
            homeApi
                .dictcode({
                    code: 'resource_origin'
                })
                .then((res) => {
                    that.resource_originlist = res.data.data
                })
        },
        dictcode2() {
            let that = this
            homeApi
                .dictcode({
                    code: 'resource_step'
                })
                .then((res) => {
                    that.resource_steplist = res.data.data
                })
        },
        dictcode4() {
            let that = this
            homeApi
                .dictcode({
                    code: 'school_feature'
                })
                .then((res) => {
                    that.bookLevelList = res.data.data
                })
        },
        dictcode5() {
            let that = this
            homeApi
                .dictcode({
                    code: 'book_level'
                })
                .then((res) => {
                    that.bookLevelLists = res.data.data
                })
        },
    }
}
</script>

<style lang="less" scoped>
.el-form-item {
    margin-bottom: 0px;
}

.yanse {
    color: #999;
}
</style>


// WEBPACK FOOTER //
// src/components/platform/resources.vue